// extracted by mini-css-extract-plugin
module.exports = {"primary":"#90caf9","secondary":"#ce93d8"};